<div
  class="container iep-form-container"
  style="
    margin-bottom: 192px;
    margin-left: auto;
    margin-right: auto;
    width: 97%;
  "
>
  <div class="row">
    <div class="col-lg-12">
      <div class="panel panel-primary">
        <div class="panel-heading">
          <h4 id="heading" style="margin-bottom: 3px; margin-top: 5px">
            DCU Inventory
          </h4>
        </div>

        <div class="panel-body">
          <div class="row" *ngIf="displayAllSiteID">
            <div class="col-lg-12">
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"></div>
              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                <mat-label class="label-input" style="margin-bottom: 3px"
                  >Select Site:</mat-label
                >
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                <mat-form-field>
                  <mat-select
                    id="site-id"
                    name="siteID"
                    (selectionChange)="getDCUDetails()"
                    [(ngModel)]="siteId"
                    placeholder="Select SiteID"
                    required
                  >
                    <mat-option value="">-- Select SiteID --</mat-option>
                    <mat-option
                      *ngFor="let item of sites"
                      value="{{ item.siteId }}"
                      >{{ item.siteId }}</mat-option
                    >
                  </mat-select>
                  <mat-error>This field is required.</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div
            class="row"
            style="margin-top: 1px; margin-bottom: 5px"
            *ngIf="!displayAllSiteID"
          >
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <mat-label> Site ID : </mat-label>{{ selectedSite }}
            </div>
          </div>
          <mat-table id="table-dcu" #table [dataSource]="dcuSources">
            <ng-container matColumnDef="order">
              <mat-header-cell *matHeaderCellDef> S No.</mat-header-cell>

              <mat-cell *matCellDef="let dcu">{{ dcu.order }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dcuID">
              <mat-header-cell *matHeaderCellDef>DCU Id</mat-header-cell>
              <mat-cell *matCellDef="let dcu">{{ dcu.dcuID }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="dcuName">
              <mat-header-cell *matHeaderCellDef>DCU Name</mat-header-cell>
              <mat-cell *matCellDef="let dcu">{{ dcu.dcuName }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="firmwareVersion">
              <mat-header-cell *matHeaderCellDef
                >Firmware Version</mat-header-cell
              >
              <mat-cell *matCellDef="let dcu">{{
                dcu.firmwareVersion
              }}</mat-cell>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row *matRowDef="let dcu; columns: displayedColumns"></mat-row>
          </mat-table>

          <mat-paginator
            #paginator
            [pageSize]="10"
            [pageSizeOptions]="[10, 20, 30]"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
